<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Cavabdeh şəxs</label>
            <el-select :model-value="selectedParticipantId"
                @update:modelValue="v => $emit('update:selectedParticipantId', v)" placeholder="Seçin" size="large"
                style="width: 100%;">
                <el-option :value="0" label="Yeni" />
                <el-option v-for="person in participants" :key="person.id" :label="person.personType === 1
                    ? person.name + ' ' + (person.surname || '') + ' ' + (person.fatherName || '')
                    : person.name" :value="person.id" />
                <template #empty>
                    <div style=" color: #999; text-align: center;">Məhkəməyə göndərilmiş iştirakçı yoxdur</div>
                </template>
            </el-select>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <soft-button type="button" @click="$emit('save')">Yadda saxla</soft-button>
            &nbsp;&nbsp;
            <soft-button type="button" color="secondary" @click="$emit('cancel')">İmtina</soft-button>
        </div>
    </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";

export default {
    components: { SoftButton },
    props: {
        participants: { type: Array, default: () => [] },
        selectedParticipantId: { type: [Number, null], default: null }
    },
    emits: ["update:selectedParticipantId", "save", "cancel"]
};
</script>
